import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { acceptBackgroundUpdateRequestByUser } from '../../../../actions/backgroundActions'
import { requestAcceptObjectievEdit } from '../../../../actions/objectivesActions'
import { acceptAudienceUpdateRequestByUser } from '../../../../actions/audienceActions'
import { acceptProjectTimelineUpdateRequestByUser } from '../../../../actions/projectTimelineActions'
import { acceptDocumentUpdateRequestByUser } from '../../../../actions/supportingDocsActions'

import logo from '../../../../assets/icons/MetaBrief_horizontal_RBG.jpg'

const AcceptEditRequest = (props) => {

    const history = useHistory();
    const dispatch = useDispatch();
    const [projectID, setProjectID] = useState()
    const [code, setCode] = useState()
    const [inputTitle, setInputTitle] = useState()
    const [inputID, setInputID] = useState()

    const { user, loading } = useSelector(state => state.auth)
   
    useEffect(() => {
        const queryParams = new URLSearchParams(props.location.search)
        const url = `${props.location.pathname}${props.location.search}`;
        localStorage.setItem('redirectUrl', url);
        //console.log(url)
        if(!user) history.push('/login')
        if(props.match.params.token){
            const code = props.match.params.token;
            setInputTitle(props.match.params.type)
            const projectId = queryParams.get("project_id")
            setProjectID(projectId);
            setCode(code);
            const id = queryParams.get("id")
            if (queryParams.get("id")) {
                setInputID(id);
            }
        }
        
    }, [props,history, user])

   
    const handleClickAcceptInvitation = (acceptStatus) => {
        const formData = {
            token: code,
            isAccepted: acceptStatus,
            project_id: projectID,
        }
        if (inputTitle === "audience" || inputTitle === "timeline-strategy") {
            formData.id = inputID 
        }
        var dispatchFunction
		if(inputTitle === "background")  dispatchFunction = acceptBackgroundUpdateRequestByUser(formData, history)
		else if(inputTitle === "objective") dispatchFunction = requestAcceptObjectievEdit(formData, history)
		else if(inputTitle === "audience") dispatchFunction = acceptAudienceUpdateRequestByUser(formData, history)
		else if(inputTitle === "timeline-strategy") dispatchFunction = acceptProjectTimelineUpdateRequestByUser(formData, history)
		else if(inputTitle === "supporting_documents") dispatchFunction = acceptDocumentUpdateRequestByUser(formData, history)
		else return false;
		dispatch(dispatchFunction);
    }
    return (
        <div id="wrapper" className="a uth-main">
            <div className="container">
                <div className="row clearfix">
                    <div className='col-md-4 mx-auto'>
                        <div className="card custom_card border-radius-10">
                            <div className="header text-center pb-0">
                                <p className="lead"><span className="navbar-brand" ><img src={logo} width="110" height="auto" className="img-fluid mt-2" alt="" /></span></p>
                                <h4 className="lead"><strong>Accept {inputTitle} update</strong></h4>
                            </div>
                            <div className="body">
                                <div className="body modal-body">
                                    <div className="form-auth-small">
                                        <div className="form-group">
                                            <label>Accept invitation edit {inputTitle} for owners</label>
                                        </div>
                                        <div className='row'>
                                            <div className='col-sm-12 col-md-6 col-lg-6'>
                                                <button className="btn custom-btn-outline-info btn-sm btn-block" onClick={() => handleClickAcceptInvitation(true)} disabled={loading ? true : false}>Accept</button>
                                            </div>
                                            <div className='col-sm-12 col-md-6 col-lg-6'>
                                                <button className="btn btn-outline-danger btn-sm btn-block" onClick={() => handleClickAcceptInvitation(false)}>Decline</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AcceptEditRequest;
